import React, { useState, useEffect } from 'react';
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.license-padding {\n  padding: 50px 15px;\n}\n.style-table-border td {\n  border-bottom: 1px solid #dae7ec;\n  border-top: none;\n  padding: 20px 0 !important;\n}\n.align-second-col {\n  text-align: right;\n}\nth:first-child, td:first-child {\n  padding-left: 0 !important;\n}\n\nth:last-child, td:last-child {\n  padding-right: 0;\n}\n.style-table-border th:first-child, .style-table-border td:first-child {\n  text-align: left;\n}";
styleInject(css_248z);
function App() {
  // State to hold the license data
  const [licenseData, setLicenseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch license data from API
  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const url = process.env.GATSBY_BACKEND_URL || 'https://api3.getmybubble.io';
        const response = await fetch(url + "/library", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            library_function: "getLicenceData",
            arguments: {},
            environment: "stage"
          })
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        if (result && result.data) {
          setLicenseData(result.data);
        } else {
          throw new Error("Invalid API response structure.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLicenseData();
  }, []);

  // Sort the license data alphabetically by state_name
  const sortedLicenseData = [...licenseData].sort((a, b) => a.state_name.localeCompare(b.state_name));
  return /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 license-padding"
  }, loading ? /*#__PURE__*/React.createElement("p", null, "Loading...") : error ? /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'red'
    }
  }, "Error: ", error) : /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("tbody", null, sortedLicenseData.map((item, index) => /*#__PURE__*/React.createElement("tr", {
    key: index,
    className: "style-table-border"
  }, /*#__PURE__*/React.createElement("td", null, item.state_name), /*#__PURE__*/React.createElement("td", {
    className: "align-second-col"
  }, item.license))))));
}
export { App as LicensePage };